define('../src/journeys/j8-visitor-registration/j8-visitor-registration',['jquery', 'lib/utils'], function($, utils) {

    'use strict';

    var J8_VISIT = function($journey) {

        this.$journey = $journey;

        return this;
    };

    J8_VISIT.prototype.init = function() {
        var _this = this;

        this.$journey.find('.mobile-dis-link').on('click',function(){
            if($(window).width() < 1025){
                var _this = this,
                thisContent = $('.j8-visit-reg--moreinfo').html(),
                thisModal = $('.m18-modal--disclaimer'),
                thisModalTrigger = thisModal.find('.m18-modal__trigger'),
                thisModalContent = thisModal.find('.m18-modal__content');

                thisModalContent.html(thisContent);
                thisModalTrigger.trigger('click');
            }
        })
    };

    return J8_VISIT;
});

